<div class="card column overflow">
	<div>
		<div class="flex space-between">
			<h4>{{'general.upload_file' | translateWithKeys}}</h4>
			<button class="align-end" mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
		</div>
		@if (uploadOnCourse) {
			<p class="body1">{{'course-creation.upload_video_inside_course' | translateWithKeys}}</p>
		} @else {
			<p class="body1">{{'course-creation.add_language_for_uploaded_files' | translateWithKeys}}</p>
		}
		@if(!hasFile){
			<br>
			<div class="card-container">
				<img class="default-img" src="../../../assets/images/video.webp" alt="Video">
				<div class="flex column center">
					<span class="title2 m-0">{{'general.file' | translateWithKeys}}</span>
					<p class="caption">{{ 'course-creation.select_video_media_library' | translateWithKeys }}</p>
				</div>
				@if (!uploadOnCourse) {
					<button class="view-btn button bg-primary-darker text-accent-lighter upload-btn" mat-button  (click)="coverVideo.click()"><mat-icon svgIcon="upload_outlined" class="upload-icon"></mat-icon>{{'general.upload' | translateWithKeys}}</button>
				}@else {

					<button class="view-btn button bg-primary-darker text-accent-lighter upload-btn" mat-button  (click)="coverCourseVideo.click()"><mat-icon svgIcon="upload_outlined" class="upload-icon"></mat-icon>{{'general.upload' | translateWithKeys}}</button>
				}
			</div>
		}
		<br>
		@if(hasFile){
			<app-table #tableComponent [dataSource]="videos" [table]="table" [isDeleted]="true" (selectedItems)="deleteVideo($event)"></app-table>
			<div class="align-btn">
				@if (!uploadOnCourse) {
					<button class="btn-border border-accent btn-upload-more" mat-button  (click)="coverVideo.click()"><mat-icon svgIcon="upload_simple"></mat-icon>{{'general.upload_more' | translateWithKeys}}</button>
				}
			</div>

		}
		<input #coverVideo hidden type="file" (change)="fileChangeEvent($event)" (click)="model.thumbnail= ''" name="coverImage" [accept]="acceptFiles" #fileInputMultiple multiple>
		<input #coverCourseVideo hidden type="file" (change)="fileChangeEvent($event)" (click)="model.thumbnail= ''" name="coverImage" [accept]="acceptFiles" #fileInput >
	</div>

</div>
@if(hasFile){
	<div class="footer">
		<div>
			@if(hasTranslation){
				<div class="bg-warning-lighter warning-message">
					<mat-icon color="text-warn" svgIcon="warning"></mat-icon><span class="text-warn">{{'general.please_select_language' | translateWithKeys}}</span>
				</div>
			}
		</div>
		<div class="container-btn">
			<button class="view-btn btn-border border-accent" mat-flat-button (click)="close()">{{'general.cancel' | translateWithKeys}}</button>
			<button class="view-btn bg-primary-darker text-accent-lighter" mat-flat-button (click)="save()">{{'general.save' | translateWithKeys}}</button>
		</div>
	</div>
}

<ng-template #videoThumbnail let-element="element">
	<div class="thumbnail-and-name" >
		<div class="img-container">
			@if (element?.fileType === MediaFiles.PDF) {
				<img class="img-table inherit-fit" [src]="element.thumbnail" alt="img">
			} @else {
				<img class="img-table" [src]="element.thumbnail" alt="img">
			}
		</div>
		@if (element?.__editFileNameTitle) {
			<div class="density-5 flex row center gap">
				<mat-form-field appearance="outline" class="edit-file-name-input">
					<input #editInput matInput type="text" [(ngModel)]="element.fileName" (keyup)="submitNewName($event, element)">
				</mat-form-field>
				<button mat-icon-button (click)="confirmFileName(element)">
					<mat-icon class="edit-icon pointer">check</mat-icon>
				</button>
				<button mat-icon-button (click)="maintainPreviousFileName(element)">
					<mat-icon class="edit-icon pointer">close</mat-icon>
				</button>
			</div>
		} @else {
			<div class="flex row start-center gap">
				<p class="m-0">{{element?.fileName | truncate:45}}</p>
				<mat-icon svgIcon="edit" class="edit-icon pointer" (click)="editFileTitle(element)"></mat-icon>
			</div>
		}

	</div>
</ng-template>

<ng-template #videoDuration let-element="element">
	<p class="mt-15">{{element.duration | timeFormat }}</p>
</ng-template>

<ng-template #addLanguage let-element="element">
	@if (data?.lang) {
		<mat-chip>{{data?.lang?.translation?.name | translateWithKeys}}</mat-chip>
	} @else {
		@if (!element.language){
			<div class="container-plus-add">
				<mat-chip  (click)="openOverlay($event, element)"><mat-icon svgIcon="plus"></mat-icon> Add</mat-chip>
			</div>
		} @else {
			<mat-chip (click)="openOverlay($event, element)">{{element.language.name | translateWithKeys}}</mat-chip>
		}
	}
</ng-template>

<ng-template #descriptionTemplate let-element="element">
	@if (element?.description) {
		<div class="flex row start-center gap">
			<p class="m-0">{{element?.description | truncate:20}}</p>
			<mat-icon svgIcon="edit" class="edit-icon pointer" (click)="openDescriptionDialog(element)"></mat-icon>
		</div>
	} @else {
		<button mat-icon-button (click)="openDescriptionDialog(element)">
			<mat-icon svgIcon="plus"></mat-icon>
		</button>
	}
</ng-template>
